<template>

	<div class="form-wrapper">
		<div class="form-container"></div>

		<div class="row" v-if="resetPasswordUUID">
			<div class="col-20">
				<br>
				<br>
				<br>
				<h2>Change password</h2>
				<form novalidate data-password-reset="true" style="max-width: 533px;" :data-uuid="resetPasswordUUID">
					<ul class="form">
						<li>
							<label><span>New password</span></label>
							<input type="password" name="new-password" pattern="\S{2,}" required>
						</li>
						<li>
							<label><span>New password</span></label>
							<input type="password" name="new-repeated-password" pattern="\S{2,}" required>
						</li>
						<li>
							<p class="error-message hidden">Passwords do not match</p>
							<input type="submit" class="btn" value="Change password">
						</li>
					</ul>
				</form>
			</div>
		</div>

		<div class="form-loader">
			<div class="loader transition-fadeinup">
				<p>Loading form</p>
			</div>
		</div>

	</div>

</template>

<script>

import formCreator from '../../modules/forms/formCreator.js'
import formModule from '../../modules/forms/formModule.js'
import xhrModule from '../../modules/xhrModule.js'
import general from '../../modules/general.js'
import formResourcesManager from '../../modules/forms/formResourcesManager.js'
import editableReferencesDeleter from '../../modules/forms/editableReferencesDeleter.js'

export default {
	name: 'itemContent',
	props: {
		entities: Array,
		markets: Object
	},
	watch: {
		entities: function (newVal, oldVal) {
			formResourcesManager.entities = newVal
			this.fetchEntity()
		},

		markets: function (newVal, oldVal) {
			formResourcesManager.markets = newVal
			this.getLanguagesCompleteHandler()
		}
	},
	data () {
		return {
			formData: null,
			mainslug: this.getMainSlug(),
			resetPasswordUUID: null
		}
	},

	created () {
		this.body = document.querySelector('body')
		this.body.classList.add('form-loading')
		this.entityid = this.$route.params.entityid
		this.uuid = this.$route.params.id
		this.int = 0
		this.entityID = null

		if (this.entities) {
			formResourcesManager.entities = this.entities
			this.fetchEntity()
		}

		// fetch entities when we are showing forms for users or roles
		if (this.entityid == 24 || this.entityid == 25) {
			var url = '/cms/api/entities'
			xhrModule.get(url, this.entitiesFetched.bind(this))
		}

		if (Object.keys(formResourcesManager.markets).length > 0) {
			this.getLanguagesCompleteHandler()
		} else {
			if (this.markets) {
				formResourcesManager.markets = this.markets
				this.getLanguagesCompleteHandler()
			}
		}
	},

	beforeDestroy () {
		formResourcesManager.reset()
	},

	methods: {
		entitiesFetched: function (data) {
			formResourcesManager.entities = data.data
			this.fetchEntity()
		},

		fetchEntity () {
			var entities = Object.values(formResourcesManager.entities)

			for (var i = entities.length - 1; i >= 0; i--) {
				if (entities[i].id == this.entityid) {
					this.getEntityCompleteHandler(entities[i])
				}
			}
		},

		getEntityCompleteHandler (entity) {
			if (!entity) this.$router.push('/content')
			this.entityID = entity.id
			this.entity = entity

			this.fetchFormData()
			this.fetchInstances()
		},

		fetchFormData () {
			var url = '/cms/api/forms?entity=' + this.entityID
			xhrModule.get(url, this.getFormsCompleteHandler.bind(this))
		},

		getFormsCompleteHandler (forms) {
			// when there is no form data we will stop rendering
			if (Object.keys(forms.data).length === 0) return
			this.formData = forms.data[Object.keys(forms.data)[0]]
			this.findAmountOfFormsToRender()
		},

		getLanguagesCompleteHandler () {
			if (this.langComplete) return
			this.langComplete = true
			var data = formResourcesManager.markets

			// only strip out cms lang for entities other than users and roles
			if (this.entityid != 24 && this.entityid != 25) {
				// strip out the CMS language
				for (var l in data) {
					if (data[l].id === 1) delete data[l]
				}
			}

			this.languages = data
			this.findAmountOfFormsToRender()
		},

		fetchInstances () {
			if (!this.uuid) {
				this.instances = null
				this.findAmountOfFormsToRender()
			} else {
				var url = '/cms/api/instances?uuid2=' + this.uuid
				xhrModule.get(url, this.getInstancesCompleteHandler.bind(this))
			}
		},

		getInstancesCompleteHandler (instances) {
			this.instances = instances.data

			Object.keys(this.instances).map(i => {
				this.instances[i].entity = instances.linked.entity[this.instances[i].entity]
				this.instances[i].market = instances.linked.market[this.instances[i].market]
				Object.keys(this.instances[i].data).map((k) => {
					this.instances[i].data[k] = {
						id: this.instances[i].data[k].id,
						property: Object.keys(this.instances[i].entity.properties).reduce((a, e) => {
							return this.instances[i].entity.properties[e].name === k ? this.instances[i].entity.properties[e] : a
						}),
						state: 3,
						value: this.instances[i].data[k].value
					}
				})
			})

			this.findAmountOfFormsToRender()
		},

		findAmountOfFormsToRender () {
			this.body.classList.add('form-loading')
			this.totalFormsToRender = 1
			this.startUniformCounter = 0
			this.editablerefsData = []

			this.int++
			if (this.int === 3) {
				this.totalEditableRefs = 0
				this.editableRefsCounter = 0

				let loopInt = 0
				const amountElements = Object.keys(this.formData.elements).length
				for (let element in this.formData.elements) {
					loopInt++
					const type = this.formData.elements[element].property.settings.type.value
					if (type === 'Editable reference') {
						this.totalEditableRefs++
						const entityID = this.formData.elements[element].property.settings.referenceId.value
						formResourcesManager.fetchForm(this.getEditableRefFormsCompleted.bind(this), entityID)
					}

					if (loopInt === amountElements) {
						// when there are no editable references we can just render the form
						if (this.totalEditableRefs === 0) this.renderForm()
					}
				}
			}
		},

		getEditableRefFormsCompleted (data) {
			this.editablerefsData.push(data)

			this.editableRefsCounter++
			if (this.totalEditableRefs === this.editableRefsCounter) {
				// find out how many instances there are for each of these editable references in order to know how many forms there will need to be rendered
				for (var i = this.editablerefsData.length - 1; i >= 0; i--) {
					const entityID = this.editablerefsData[i][Object.keys(this.editablerefsData[i])[0]].entity.id

					if (this.instances && Object.keys(this.instances).length > 0) {
						const dataProps = this.instances[Object.keys(this.instances)[0]].data
						for (let prop in dataProps) {
							if (dataProps[prop].property) {
								if (dataProps[prop].property.settings) {
									if (dataProps[prop].property.settings.referenceId) {
										const refValue = dataProps[prop].property.settings.referenceId.value
										if (refValue == entityID) {
											const values = dataProps[prop].value
											this.totalFormsToRender = this.totalFormsToRender + values.length
										}
									}
								}
							}
						}
					}

					if (i === 0) this.renderForm()
				}
			}
		},

		renderForm () {
			editableReferencesDeleter.clearQueue()

			// check if we are editing a user and if so we will not prefill his password but we create another form to change the password
			var hidePassword = false
			if (this.entity.name === 'users' && this.instances) {
				this.resetPasswordUUID = JSON.stringify(this.instances)
				hidePassword = true
			}

			var container = document.querySelector('.form-container')
			formCreator({
				layout: 'multiple',
				data: this.formData,
				languages: this.languages,
				instances: this.instances,
				container: container,
				entity: this.entity,
				callback: this.postCompleted,
				editableReference: false,
				hidePassword: hidePassword,
				startUniform: this.startUniform.bind(this)
			}).init()
		},

		startUniform (callback) {
			this.startUniformCounter++
			if (this.startUniformCounter === this.totalFormsToRender || this.startUniformCounter > this.totalFormsToRender) {
				// debounce the initialisation of the form module in case there are a lot of editable references (forms)
				clearTimeout(this.debouncer)

				this.debouncer = setTimeout(function () {
					formModule.init(callback)
				}, 200)
			}
		},

		postCompleted () {
			general.saveAnimation()
			if (this.mainslug === 'users') {
				this.$router.push('/' + this.mainslug)
			} else if (this.mainslug === 'pages') {
				this.$router.push('/' + this.mainslug)
			} else if (this.mainslug === 'roles') {
				this.$router.push('/users/' + this.mainslug)
			} else {
				this.$router.push('/' + this.mainslug + '/' + this.entityid)
			}
		},

		getMainSlug () {
			var pathName = window.location.pathname
			return pathName.split('/')[1]
		}
	}
}

</script>
